import React, { Component } from 'react'
import { CheckBoxContainer } from './index.style'

export default class Checkbox extends Component {
  state = {
    isChecked: false,
  }

  componentDidUpdate(prevProps) {
    const { isChecked } = this.props
    if (prevProps.isChecked !== isChecked)
      this.setState({ isChecked: isChecked })
  }

  toggleCheckboxChange = () => {
    const { onChange, label } = this.props

    this.setState(({ isChecked }) => ({
      isChecked: !isChecked,
    }))

    if (onChange) onChange(label)
  }

  render() {
    const { label, isChecked } = this.props

    return (
      <CheckBoxContainer>
        <label className="flex items-center word-wrap">
          <input
            className="mr2 flex-none"
            type="checkbox"
            color="red"
            value={label}
            checked={isChecked}
            onChange={this.toggleCheckboxChange}
          />
          <span className="checkmark"></span>
          {label}
        </label>
      </CheckBoxContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js